import React, { useState } from "react";
import { IoIosChatbubbles, IoMdSend } from "react-icons/io";
import { FaTimes, FaArrowLeft, FaWindowMinimize } from "react-icons/fa";
import { BASE_URL } from "./Baseurl";
import axios from "axios";

const issueCategories = [
  "Event, tickets",
  "Registrations",
  "Cancellation",
  "Technical Support",
  "Event Posting / Publishing",
  "Other",
];

const ChatBot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false); // New state for minimize
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    category: "",
  });

  const [chatSessionId, setChatSessionId] = useState(null);


  const toggleChat = () => {
    // If minimizing, open should reset minimize
    if (isOpen && !isMinimized) {
      setIsMinimized(true); // minimize if open
    } else if (isOpen && isMinimized) {
      setIsMinimized(false); // restore chat
    } else {
      setIsOpen(true);
      setIsMinimized(false);
    }
    if (!isOpen) {
      setFormSubmitted(false);
      setMessages([]);
      setFormData({ name: "", email: "", phone: "", category: "" });
    }
  };

  const minimizeChat = () => {
    setIsMinimized(true);
  };

  const restoreChat = () => {
    setIsMinimized(false);
  };

  const goBackToForm = () => {
    setFormSubmitted(false);
    setMessages([]);
  };



  const downloadTranscript = (messages, user) => {
    const transcript = [
      `Name: ${user.name}`,
      `Email: ${user.email}`,
      `Phone: ${user.phone}`,
      `Issue: ${user.category}`,
      "",
      "Chat Transcript:",
      ...messages.map((msg) => `${msg.sender}: ${msg.message}`),
    ].join("\n");

    const blob = new Blob([transcript], { type: "text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `chat_transcript_${Date.now()}.txt`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleStartChat = async (e) => {
    e.preventDefault();

    console.log("Sending chat start data:", formData); // 🔍 Log the data

    try {
      const response = await axios.post(`${BASE_URL}insertChatbotQuery`, formData);

      console.log("response", response);

      if (response.status === 201) {

        const id = response.data.query.id;
setChatSessionId(id);
console.log("chatSessionId from response:", id);

      

        setFormSubmitted(true);
        setMessages([
          {
            sender: "Support",
            message: `Hi ${formData.name}, how can we assist you regarding ${formData.category.toLowerCase()}?`,
          },
        ]);
      } else {
        throw new Error("Unexpected response from server");
      }
    } catch (error) {
      alert("There was an error starting the chat. Please try again later.");
      console.error("Chat start error:", error);
    }
  };



  const handleSendMessage = async () => {

     console.log("chatSessionId in handleSendMessage:", chatSessionId);
  if (!newMessage.trim() || !chatSessionId) {
    console.log("Message or chatSessionId missing, aborting send");
    return;
  }
 
  // Append message to UI immediately
  setMessages((prev) => [
    ...prev,
    { sender: "You", message: newMessage },
    {
      sender: "Support",
      message: "Thanks for your message. Our team will respond shortly.",
    },
  ]);

  // Prepare data
  const dataToSend = {
    chatbot_query_id: chatSessionId,  // 🔗 Link with session
    message: newMessage,
    sender: "user",                   // or "customer"
  };

  // Log the data being sent
  console.log("Sending chat message data:", dataToSend);

  // Save message to backend
  try {
    await axios.post(`${BASE_URL}insertChatbotMessage`, dataToSend);
  } catch (err) {
    console.error("Failed to send message:", err);
  }

  // Clear input
  setNewMessage("");
};



  return (
    <>
      {/* Floating Toggle Button */}
      <button
        onClick={toggleChat}
        className="chatbot-toggle-btn btn   rounded-circle shadow p-0"
        aria-label="Toggle ChatBot"
        style={{ width: "48px", height: "48px", backgroundColor: '#01B957', }}
      >
        {isOpen && !isMinimized ? <FaTimes size={25} /> : <IoIosChatbubbles size={25} />}
      </button>

      {/* Chat Window */}
      {isOpen && !isMinimized && (
        <div
          className="chatbot-window card shadow position-fixed bottom-0 end-0 m-3 bgchat"
          style={{ width: "320px", zIndex: 1050 }}
        >
          <div className="card-header text-white d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              {formSubmitted && (
                <button
                  onClick={goBackToForm}
                  className="btn btn-link btn-sm text-white me-2 p-0"
                  aria-label="Back to form"
                  style={{ fontSize: "18px", lineHeight: "1" }}
                >
                  <FaArrowLeft />
                </button>
              )}
              <div>
                <h5 className="mb-0">Eventoz Help Center</h5>
                <small>{formSubmitted ? "Live Chat" : "Start a Conversation"}</small>
              </div>
            </div>

            <button
              onClick={minimizeChat}
              className="btn btn-link btn-sm text-white p-0"
              aria-label="Minimize chat"
              style={{ fontSize: "18px", lineHeight: "1" }}
            >
              <FaWindowMinimize />
            </button>
          </div>

          {!formSubmitted ? (
            <form className="p-3" onSubmit={handleStartChat}>
              <div className="mb-2">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Your Name"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                />
              </div>
              <div className="mb-2">
                <input
                  type="email"
                  className="form-control form-control-sm"
                  placeholder="Your Email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                />
              </div>
              <div className="mb-2">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Phone Number"
                  required
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                />
              </div>
              <div className="mb-3">
                <select
                  className="form-select form-select-sm"
                  required
                  value={formData.category}
                  onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                >
                  <option value="">Choose the category of your Query</option>
                  {issueCategories.map((cat) => (
                    <option key={cat} value={cat}>
                      {cat}
                    </option>
                  ))}
                </select>
              </div>
              <button type="submit" className="btn btn-primary w-100 btn-sm">
                Start Chat
              </button>
            </form>
          ) : (
            <>
              <div className="chatbot-user-info border-bottom p-2 position-relative">
                <div className="mstxt small mb-2">
                  <strong>Note:</strong> Our support team is currently unavailable. Please leave your query below and we will notify you on email as soon as possible.
                </div>
                <div className="small text-start mstxt">
                  <div>
                    <strong>Name:</strong> {formData.name}
                  </div>
                  <div>
                    <strong>Email:</strong> {formData.email}
                  </div>
                  <div>
                    <strong>Phone:</strong> {formData.phone}
                  </div>
                  <div>
                    <strong>Issue:</strong> {formData.category}
                  </div>
                  <button
                    className="btn btn-link btn-sm p-0 mt-1 text-success"
                    onClick={() => setFormSubmitted(false)}
                  >
                    &larr; Back to Edit Details
                  </button>
                </div>

                {/* 3-dot menu */}
                {/* <div className="dropdown position-absolute top-0 end-0 m-2">
                  <button
                    className="btn btn-sm btn-light border-0 dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    aria-label="Options"
                  >
                    &#8942;
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <button className="dropdown-item" onClick={() => downloadTranscript(messages, formData)}>
                        Download Transcript
                      </button>
                    </li>
                  </ul>
                </div> */}
              </div>

              <div className="chatbot-messages card-body overflow-auto" style={{ height: "220px" }}>
                {messages.map((msg, idx) => (
                  <div
                    key={idx}
                    className={`mb-2 p-2 rounded ${
                      msg.sender === "You"
                        ? "bg-primary text-white text-end"
                        : "bg-light text-dark text-start"
                    }`}
                    style={{ maxWidth: "85%", marginLeft: msg.sender === "You" ? "auto" : "0" }}
                  >
                    <small><strong>{msg.sender}</strong></small>
                    <div>{msg.message}</div>
                  </div>
                ))}
              </div>

              <div className="chatbot-input p-2 border-top d-flex align-items-center">
                <input
                  type="text"
                  className="form-control form-control-sm me-2"
                  placeholder="Type your message..."
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      handleSendMessage();
                    }
                  }}
                />
                <button
                  onClick={handleSendMessage}
                  className="btn btn-primary btn-sm"
                  aria-label="Send message"
                >
                  <IoMdSend />
                </button>
              </div>
            </>
          )}
        </div>
      )}

      {/* Minimized bar */}
      {isOpen && isMinimized && (
        <div
          className="chatbot-minimized position-fixed bottom-0 end-0 m-3 bg-primary text-white rounded shadow d-flex align-items-center px-3"
          style={{ height: "40px", cursor: "pointer", zIndex: 1050,backgroundColor: '#01B957', }}
          onClick={restoreChat}
          role="button"
          aria-label="Restore chat"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              restoreChat();
            }
          }}
        >
          <IoIosChatbubbles size={24} className="me-2" />
          <small>Chat minimized. Click to restore.</small>
        </div>
      )}
    </>
  );
};

export default ChatBot;
